var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#5062F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3536 23.8536C16.1583 24.0488 15.8417 24.0488 15.6464 23.8536L11.4798 19.6869C11.2845 19.4916 11.2845 19.175 11.4798 18.9798C11.675 18.7845 11.9916 18.7845 12.1869 18.9798L15.5 22.2929L15.5 13.5C15.5 13.2239 15.7239 13 16 13C16.2761 13 16.5 13.2239 16.5 13.5V22.2929L19.8131 18.9798C20.0084 18.7845 20.325 18.7845 20.5202 18.9798C20.7155 19.175 20.7155 19.4916 20.5202 19.6869L16.3536 23.8536ZM23.5 14C23.2239 14 23 13.7761 23 13.5L23 10.1667C23 9.85725 22.8771 9.5605 22.6583 9.34171C22.4395 9.12292 22.1428 9 21.8333 9L10.1667 9C9.85725 9 9.5605 9.12292 9.34171 9.34171C9.12292 9.5605 9 9.85725 9 10.1667V13.5C9 13.7761 8.77614 14 8.5 14C8.22386 14 8 13.7761 8 13.5V10.1667C8 9.59203 8.22827 9.04093 8.6346 8.6346C9.04093 8.22827 9.59203 8 10.1667 8L21.8333 8C22.408 8 22.9591 8.22827 23.3654 8.6346C23.7717 9.04093 24 9.59203 24 10.1667L24 13.5C24 13.7761 23.7761 14 23.5 14Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadDown);
export default __webpack_public_path__ + "static/media/download_down.a321650dc7c05903dac9da8775e48cec.svg";
export { ForwardRef as ReactComponent };